import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import theme from './theme';
// application Vocational One & Junior
import RedirectPage from './Pages/RedirectPage';
import SwitchPage from './Pages/SwitchPage';
import SingleSwitchPage from './Pages/SingleSwitchPage';
// complete pages
import TestPage from './Pages/Test';
import IndexPage from './Pages/Index';
import DataParserPage from './Pages/DataParser';
import DataParserJunior from './Pages/DataParserJunior';
import DataParserStart from './Pages/DataParserStart';

// component pages
// import BigFivePage from './Pages/BigFive';
// import DemographicsPage from './Pages/Demographics';
// import LearningAgilityPage from './Pages/LearningAgility';
// import GFNExamplePage from './Pages/GFNExample';
// import GFNCompletePage from './Pages/GFNComplete';
// import FinishedPage from './Pages/Finished';
import { StageProvider, StageConsumer } from './Context';
import './index.css';

class App extends React.Component {
  render() {
    return (
      <StageProvider>
        <StageConsumer>
          {({ state, nextStage }) => {
            return (
              <ThemeProvider theme={theme}>
                <Router>
                  <>
                    <Route path='/' exact component={RedirectPage} />
                    <Route path='/c/:id' exact component={SwitchPage} />
                    <Route path='/r/:id' exact component={SingleSwitchPage} />

                    <Route path='/repo' exact component={TestPage} />
                    <Route path='/testing' exact component={IndexPage} />
                    <Route
                      path='/testing/parser'
                      exact
                      component={DataParserPage}
                    />
                    <Route
                      path='/parser/one'
                      exact
                      component={DataParserPage}
                    />
                    <Route
                      path='/parser/junior'
                      exact
                      component={DataParserJunior}
                    />
                    <Route
                      path='/parser/start'
                      exact
                      component={DataParserStart}
                    />

                    {/* <Route
                      path='/demographics'
                      exact
                      component={DemographicsPage}
                    />
                    <Route
                      path='/learning-agility'
                      component={LearningAgilityPage}
                    />
                    <Route path='/big-five' exact component={BigFivePage} />
                    <Route path='/gfn-example' component={GFNExamplePage} />
                    <Route path='/gfn-complete' component={GFNCompletePage} />

                    <Route path='/finished' component={FinishedPage} /> */}
                  </>
                </Router>
              </ThemeProvider>
            );
          }}
        </StageConsumer>
      </StageProvider>
    );
  }
}
export default App;
